<template>
  <div
    class="pop_section_8 flex-col"
    v-if="visible"
  >
    <div class="pop_box_9 flex-col justify-between">
      <div class="pop_section_9 flex-col">
        <div class="pop_group_21 flex-row">
          <div class="pop_text-wrapper_7 flex-col">
            <span class="pop_text_17">{{ index }}</span>
          </div>
          <span class="pop_text_18">{{ answerInfo.taskName }}</span>
          <img
            class="pop_label_10"
            referrerpolicy="no-referrer"
            src="../../assets/teacher/records/FigmaDDSSlicePNG888875d48bd2042e840949c853bf5507.png"
            @click="onClickClose"
          />
        </div>
        <div class="pop_section_11 flex-col">
          <div class="pop_text-wrapper_19 flex-row">
            <span class="pop_text_20">名字</span>
            <span class="pop_text_21">状态</span>
            <span class="pop_text_22">尝试次数</span>
            <span class="pop_text_23">得分</span>
            <span class="pop_text_24">教师评分</span>
            <span class="pop_text_25">教师评语</span>
            <span
              class="pop_text_26"
              @click="openRatingDialog"
              >编辑</span
            >
          </div>
          <div class="pop_text-wrapper_9 flex-row">
            <span class="pop_text_28">{{ answerInfo.studentName }}</span>
            <span class="pop_text_29">{{
              answerInfo.statu == -1
                ? "未尝试"
                : (answerInfo.statu == 0
                ? "已尝试"
                : "已完成")
            }}</span>
            <span class="pop_text_30">{{ answerInfo.attemptCount }}</span>
            <span class="pop_text_31">{{ answerInfo.score }}</span>
            <span class="pop_text_32">{{ answerInfo.teacherScore }}</span>
            <span class="pop_text_33">{{ answerInfo.teacherComment }}</span>
          </div>
        </div>
      </div>
      <div class="pop_block_7 flex-row">
        <div class="editor_left">
          <MonacoEditor
            :code="code1"
            :options="leftOptions"
          />
        </div>
        <div class="editor_right">
          <MonacoEditor
            :code="code2"
            :options="rightOptions"
          />
        </div>
      </div>
      <div class="pop_section_13 flex-col">
        <span class="pop_text_49">学生答案</span>
      </div>
      <div class="pop_section_14 flex-col">
        <span class="pop_text_50">参考答案</span>
      </div>
    </div>
  </div>

  <!-- 教师评分弹窗 -->
  <TeacherRatingDialog
    :visible="ratingDialogVisible"
    :initial-rating="answerInfo.teacherScore || -1"
    :initial-comment="answerInfo.teacherComment || ''"
    @update-visible="ratingDialogVisible = false"
    @submit="handleRatingSubmit"
  />
</template>

<script setup>
import { ref, defineProps, defineEmits} from "vue"

import MonacoEditor from "vue-monaco-editor"
import TeacherRatingDialog from "./TeacherRatingDialog.vue"
import alovaInstance from "@/utils/alova"

// 定义props
const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
    default: false,
  },
  lessonId: {
    type: Number,
    required: true,
  },
  taskId: {
    type: Number,
    required: true,
  },
  studentId: {
    type: Number,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  answerInfo: {
    type: Object,
    required: true,
    default: () => ({
      studentName: "",
      statu: -1,
      taskName: "",
      recordId: "",
      attemptCount: 0,
      score: "--",
      teacherScore: "--",
      teacherComment: "--",
    }),
  },
})

const code1 = ref("")
const code2 = ref("")
const leftOptions = ref({
  minimap: {
    enabled: false,
  },
  lineNumbers: "on",
  fontSize: 12,
  readOnly: true,
  automaticLayout: true,
  language: "python",
  glyphMargin: false,
  lineNumbersMinChars: 2,
  contextmenu: false,
  quickSuggestions: false,
  parameterHints: false,
  suggestOnTriggerCharacters: false,
})
const rightOptions = ref({
  minimap: {
    enabled: false,
  },
  lineNumbers: "on",
  fontSize: 12,
  readOnly: true,
  automaticLayout: true,
  language: "python",
  glyphMargin: false,
  lineNumbersMinChars: 2,
  contextmenu: false,
  quickSuggestions: false,
  parameterHints: false,
  suggestOnTriggerCharacters: false,
})

// 定义emits
const emit = defineEmits(["update-visible"])

// 评分弹窗状态
const ratingDialogVisible = ref(false)

// 编辑器配置
const editorOptions = ref({
  readOnly: true,
  minimap: { enabled: false },
  scrollBeyondLastLine: false,
  fontSize: 14,
  language: "python",
})

const onClickClose = () => {
  ratingDialogVisible.value = false
  emit("update-visible", false)
}

// 打开评分弹窗
const openRatingDialog = () => {
  ratingDialogVisible.value = true
}

// 提交评分
const handleRatingSubmit = async (ratingData) => {
  try {
    const response = await alovaInstance.Post("/Record/UpdateStudentRecordInfo", {
      lessonId: props.lessonId,
      taskId: props.taskId,
      studentId: props.studentId,
      recordId: props.answerInfo.recordId,
      teacherScore: ratingData.rating,
      teacherComment: ratingData.comment,
    })
    // console.log(response)
    if (response.code === 1000) {
      alert("提交数据成功。")
      ratingDialogVisible.value = false
    } else {
      alert("提交数据失败：" + response.message)
    }
  } catch (error) {
    console.error("提交数据失败:", error)
    alert("提交数据失败，请稍后重试")
  }
}
</script>

<style scoped>
.pop_section_1 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  width: 26.62vw;
  height: 39.22vw;
  margin: 15.26vw 0 0 16.51vw;
}

.pop_section_2 {
  background-color: rgba(55, 91, 165, 1);
  position: absolute;
  left: 0;
  top: 0;
  width: 15.32vw;
  height: 56.25vw;
}

.pop_group_1 {
  background-color: rgba(255, 255, 255, 1);
  height: 3.86vw;
  width: 100vw;
  position: relative;
}

.pop_group_17 {
  width: 95.58vw;
  height: 2.09vw;
  margin: 0.88vw 0 0 2.91vw;
}

.pop_label_1 {
  width: 2.09vw;
  height: 2.09vw;
}

.pop_text_1 {
  width: 3.75vw;
  height: 1.57vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.26vw 0 0 0.83vw;
}

.pop_text_2 {
  width: 5.53vw;
  height: 1.52vw;
  overflow-wrap: break-word;
  color: rgba(104, 162, 250, 1);
  font-size: 1.25vw;
  font-family: Inter-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.31vw 0 0 80.1vw;
}

.pop_text_3 {
  width: 2.5vw;
  height: 1.52vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.25vw;
  font-family: Inter-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.31vw 0 0 0.78vw;
}

.pop_text-wrapper_16 {
  width: 2.5vw;
  height: 1.1vw;
  margin: 10.31vw 0 10.52vw 94.68vw;
}

.pop_text_4 {
  width: 2.5vw;
  height: 1.1vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 0.83vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.84vw;
}

.pop_box_2 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  position: absolute;
  left: 34.74vw;
  top: 4.74vw;
  width: 10.06vw;
  height: 1.67vw;
  border: 1px solid rgba(209, 209, 209, 1);
}

.pop_group_18 {
  width: 8.91vw;
  height: 1.1vw;
  margin: 0.26vw 0 0 0.62vw;
}

.pop_text_5 {
  width: 1.46vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.72vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.pop_thumbnail_1 {
  width: 1.05vw;
  height: 1.05vw;
  margin-top: 0.06vw;
}

.pop_box_4 {
  background-color: rgba(97, 97, 97, 1);
  width: 10.06vw;
  height: 0.06vw;
  margin-top: 0.27vw;
}

.pop_box_5 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  position: absolute;
  left: 44.28vw;
  top: 15.27vw;
  width: 52.97vw;
  height: 16.88vw;
}

.pop_section_19 {
  width: 3.55vw;
  height: 2.24vw;
  margin: 1.51vw 0 0 47.91vw;
}

.pop_text_6 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.pop_group_2 {
  height: 1.05vw;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG86f2c9399bfefd666a06672deca2a065.png)
    0vw -1.05vw no-repeat;
  background-size: 1.09vw 1.09vw;
  margin-top: 1.2vw;
  width: 1.05vw;
}

.pop_block_1 {
  background-color: rgba(217, 217, 217, 1);
  width: 80.68vw;
  height: 0.11vw;
  margin: 0.88vw 0 0 -50.41vw;
}

.pop_section_4 {
  background-color: rgba(255, 255, 255, 1);
  height: 4.17vw;
  margin-top: 4.12vw;
  width: 52.97vw;
}

.pop_text-wrapper_2 {
  background-color: rgba(234, 238, 242, 1);
  border-radius: 62px;
  height: 2.61vw;
  width: 2.61vw;
  margin: 0.78vw 0 0 48.38vw;
}

.pop_text_7 {
  width: 0.79vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.46vw 0 0 0.88vw;
}

.pop_section_5 {
  background-color: rgba(247, 251, 255, 1);
  height: 4.17vw;
  margin-bottom: 0.68vw;
  width: 52.97vw;
}

.pop_text-wrapper_3 {
  background-color: rgba(234, 238, 242, 1);
  border-radius: 62px;
  height: 2.61vw;
  width: 2.61vw;
  margin: 0.78vw 0 0 48.38vw;
}

.pop_text_8 {
  width: 0.79vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.46vw 0 0 0.88vw;
}

.pop_section_6 {
  background-color: rgba(247, 251, 255, 1);
  height: 4.17vw;
  width: 52.97vw;
  position: absolute;
  left: 0;
  top: 3.7vw;
}

.pop_text-wrapper_4 {
  background-color: rgba(234, 238, 242, 1);
  border-radius: 62px;
  height: 2.61vw;
  width: 2.61vw;
  margin: 0.78vw 0 0 48.38vw;
}

.pop_text_9 {
  width: 0.79vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.46vw 0 0 0.88vw;
}

.pop_box_6 {
  background-color: rgba(85, 195, 157, 1);
  border-radius: 50%;
  position: absolute;
  left: 93.23vw;
  top: 13.29vw;
  width: 1.05vw;
  height: 1.05vw;
}

.pop_box_7 {
  background-color: rgba(217, 217, 217, 1);
  position: absolute;
  left: 16.62vw;
  top: 11.2vw;
  width: 80.63vw;
  height: 0.11vw;
}

.pop_group_19 {
  position: relative;
  width: 15.32vw;
  height: 52.45vw;
  margin-bottom: 0.06vw;
}

.pop_text-wrapper_17 {
  width: 19.12vw;
  height: 1.72vw;
  margin: 0.88vw 0 0 1.45vw;
}

.pop_text_10 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(247, 251, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.37vw;
}

.pop_text_11 {
  width: 2.5vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
}

.pop_box_23 {
  width: 15.32vw;
  height: 2.92vw;
  margin-top: 0.58vw;
}

.pop_box_8 {
  background-color: rgba(61, 197, 255, 0.5);
  width: 15.32vw;
  height: 2.92vw;
}

.pop_label_2 {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.62vw 0 0 2.7vw;
}

.pop_text_12 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.78vw 8.02vw 0 0.83vw;
}

.pop_box_24 {
  width: 15.32vw;
  height: 0.11vw;
  margin-top: 0.53vw;
}

.pop_section_7 {
  background-color: rgba(217, 217, 217, 0.2);
  width: 15.32vw;
  height: 0.11vw;
}

.pop_text-wrapper_18 {
  width: 2.09vw;
  height: 1.36vw;
  margin: 1.45vw 0 0 1.45vw;
}

.pop_text_13 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(247, 251, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.pop_box_25 {
  width: 4.59vw;
  height: 1.67vw;
  margin: 1.19vw 0 0 2.7vw;
}

.pop_label_3 {
  width: 1.67vw;
  height: 1.67vw;
}

.pop_text_14 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.16vw;
}

.pop_box_26 {
  width: 4.59vw;
  height: 1.67vw;
  margin: 1.25vw 0 0 2.7vw;
}

.pop_label_4 {
  width: 1.67vw;
  height: 1.67vw;
}

.pop_text_15 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.16vw;
}

.pop_box_27 {
  width: 4.59vw;
  height: 1.67vw;
  margin: 1.25vw 0 0 2.7vw;
}

.pop_image-text_5 {
  width: 4.59vw;
  height: 1.67vw;
}

.pop_label_5 {
  width: 1.67vw;
  height: 1.67vw;
}

.pop_text-group_1 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.16vw;
}

.pop_box_28 {
  width: 4.59vw;
  height: 1.67vw;
  margin: 1.25vw 0 0 2.7vw;
}

.pop_image-text_6 {
  width: 4.59vw;
  height: 1.67vw;
}

.pop_label_6 {
  width: 1.67vw;
  height: 1.67vw;
}

.pop_text-group_2 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.16vw;
}

.pop_box_29 {
  width: 15.32vw;
  height: 0.11vw;
  margin: 1.14vw 0 30.05vw 0;
}

.pop_block_2 {
  background-color: rgba(217, 217, 217, 0.2);
  width: 15.32vw;
  height: 0.11vw;
}

.pop_label_7 {
  position: absolute;
  left: 16.52vw;
  top: 1.1vw;
  width: 1.31vw;
  height: 1.25vw;
}

.pop_group_11 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  position: absolute;
  left: 23.49vw;
  top: 0.89vw;
  width: 10.06vw;
  height: 1.67vw;
  border: 1px solid rgba(209, 209, 209, 1);
}

.pop_group_20 {
  width: 8.91vw;
  height: 1.1vw;
  margin: 0.26vw 0 0 0.62vw;
}

.pop_text_16 {
  width: 1.46vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.72vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.pop_thumbnail_2 {
  width: 1.05vw;
  height: 1.05vw;
  margin-top: 0.06vw;
}

.pop_group_13 {
  background-color: rgba(97, 97, 97, 1);
  width: 10.06vw;
  height: 0.06vw;
  margin-top: 0.27vw;
}

.pop_section_8 {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.pop_box_9 {
  background-color: rgba(20, 20, 20, 1);
  border-radius: 32px;
  position: relative;
  width: 82.82vw;
  height: 42.3vw;
  margin: 3.5vw 0 0 8.5vw;
}

.pop_section_9 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 32px 32px 0px 0px;
  height: 9.9vw;
  width: 82.82vw;
  position: relative;
  justify-content: flex-center;
}

.pop_group_21 {
  width: 46.62vw;
  height: 3.34vw;
  margin: 1.25vw 0 0 34.42vw;
}

.pop_label_8 {
  width: 1.31vw;
  height: 1.25vw;
  margin-top: 0.84vw;
}

.pop_text-wrapper_7 {
  background-color: rgba(234, 238, 242, 1);
  border-radius: 62px;
  height: 2.61vw;
  width: 2.61vw;
  margin: 0.15vw 0 0 2.03vw;
}

.pop_text_17 {
  width: 0.79vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.46vw 0 0 0.93vw;
}

.pop_text_18 {
  width: 3.75vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.62vw 0 0 0.98vw;
}

.pop_label_9 {
  width: 1.31vw;
  height: 1.25vw;
  margin: 2.08vw 0 0 3.33vw;
}

.pop_label_10 {
  width: 1.25vw;
  height: 1.25vw;
  margin-left: 35.06vw;
  cursor: pointer;
}

.pop_image-wrapper_5 {
  width: 1.31vw;
  height: 1.25vw;
  margin: 1.56vw 0 0 8.85vw;
}

.pop_label_11 {
  width: 1.31vw;
  height: 1.25vw;
}

.pop_image-wrapper_6 {
  width: 1.31vw;
  height: 1.25vw;
  margin: 0 0 1.25vw 74.01vw;
}

.pop_label_12 {
  width: 1.31vw;
  height: 1.25vw;
}

.pop_section_11 {
  border-radius: 6px;
  position: absolute;
  left: 13.65vw;
  top: 4.48vw;
  width: 55.58vw;
  height: 4.59vw;
  border: 1px solid rgba(104, 162, 250, 0.6);
  justify-content: flex-center;
}

.pop_text-wrapper_19 {
  width: 50.73vw;
  height: 1.36vw;
  margin: 0.31vw 0 0 2.44vw;
}

.pop_text_19 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.pop_text_20 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 3.2vw;
}

.pop_text_21 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 4.85vw;
}

.pop_text_22 {
  width: 4.17vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 3.81vw;
}

.pop_text_23 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 3.86vw;
}

.pop_text_24 {
  width: 4.17vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 3.81vw;
}

.pop_text_25 {
  width: 4.17vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 2.77vw;
}

.pop_text_26 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 3.86vw;
  cursor: pointer;
}

.pop_text-wrapper_9 {
  background-color: rgba(247, 251, 255, 1);
  width: 55.4vw;
  height: 2.45vw;
  margin: 0.15vw 0 0.31vw 0;
}

.pop_text_27 {
  width: 0.58vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.94vw;
  margin: 0.62vw 0 0 3.22vw;
}

.pop_text_28 {
  width: 5.47vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.94vw;
  margin: 0.62vw 0 0 3.9vw;
}

.pop_text_29 {
  width: 2.82vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.94vw;
  margin: 0.62vw 0 0 2.81vw;
}

.pop_text_30 {
  width: 0.58vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.94vw;
  margin: 0.62vw 0 0 5.26vw;
}

.pop_text_31 {
  width: 0.84vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.94vw;
  margin: 0.62vw 0 0 6.25vw;
}

.pop_text_32 {
  width: 0.84vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.94vw;
  margin: 0.62vw 0 0 6.09vw;
}

.pop_text_33 {
  width: 0.84vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.94vw;
  margin: 0.62vw 10vw 0 6.09vw;
}

.pop_block_7 {
  width: 82.77vw;
  height: 32.4vw;
}

.pop_box_10 {
  background-color: rgba(35, 35, 35, 1);
  border-radius: 0px 0px 0 32px;
  height: 32.4vw;
  width: 4.95vw;
}

.pop_text_48 {
  width: 0.63vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 2.13vw 0 0 2.18vw;
}

.pop_group_22 {
  width: 33.86vw;
  height: 29.43vw;
  margin-top: 1.88vw;
}

.pop_group_14 {
  background-color: rgba(1, 77, 123, 1);
  height: 1.67vw;
  width: 33.86vw;
}

.pop_text-wrapper_10 {
  width: 5.53vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.15vw 0 0 0.52vw;
}

.pop_text_34 {
  width: 5.53vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(205, 169, 105, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.pop_text_35 {
  width: 5.53vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.pop_text_36 {
  width: 5.53vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(207, 106, 76, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.pop_text_37 {
  width: 5.53vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.pop_label_15 {
  width: 2.5vw;
  height: 2.5vw;
  margin: 25.26vw 0 0 29.63vw;
}

.pop_box_12 {
  background-color: rgba(39, 39, 39, 1);
  height: 32.4vw;
  margin-left: 0.06vw;
  width: 4.95vw;
}

.pop_block_3 {
  background-color: rgba(1, 77, 123, 1);
  width: 4.95vw;
  height: 4.43vw;
  margin-top: 1.88vw;
}

.pop_box_13 {
  background-color: rgba(35, 35, 35, 1);
  height: 32.4vw;
  margin-left: 0.06vw;
  width: 4.95vw;
}

.pop_paragraph_3 {
  width: 0.63vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  margin: 2.13vw 0 0 2.08vw;
}

.pop_group_23 {
  width: 33.96vw;
  height: 29.43vw;
  margin-top: 1.88vw;
}

.pop_box_15 {
  background-color: rgba(1, 77, 123, 1);
  height: 4.33vw;
  width: 33.96vw;
}

.pop_text-wrapper_11 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  margin: 0.15vw 0 0 0.52vw;
}

.pop_text_38 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(205, 169, 105, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_text_39 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_text_40 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(143, 157, 107, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_paragraph_1 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_text_41 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(205, 169, 105, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_text_42 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_text_43 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(143, 157, 107, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_paragraph_2 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_text_44 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(205, 169, 105, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_text_45 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_text_46 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(143, 157, 107, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_text_47 {
  width: 7.09vw;
  height: 4.07vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.pop_label_16 {
  width: 2.5vw;
  height: 2.5vw;
  margin: 22.6vw 0 0 29.73vw;
}

.pop_section_13 {
  background-color: rgba(217, 217, 217, 1);
  height: 1.88vw;
  border: 1px solid rgba(104, 162, 250, 0.6);
  width: 41.41vw;
  position: absolute;
  left: 0;
  top: 9.9vw;
}

.pop_text_49 {
  width: 4.17vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.26vw 0 0 17.65vw;
}

.pop_section_14 {
  background-color: rgba(217, 217, 217, 1);
  height: 1.88vw;
  border: 1px solid rgba(104, 162, 250, 0.6);
  width: 41.41vw;
  position: absolute;
  left: 41.41vw;
  top: 9.9vw;
}

.pop_text_50 {
  width: 4.17vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.26vw 0 0 20.67vw;
}

.editor_left {
  width: 50%;
  height: auto;
  min-height: 5.8vw;
  margin-top: 2vw;
}

.editor_right {
  width: 50%;
  height: auto;
  min-height: 5.8vw;
  margin-top: 2vw;
}
</style>
